var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCli(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.25 6.875H22.75L20.125 12.125H5.375V17.125H0.625L5.375 33.125H36.875V6.875H34.25ZM25.25 9.5H34.125V12.125H24L25.25 9.5ZM32.125 17.125H8.25V14.75H34.25V24.2825L32.125 17.125Z",
    fill: "#9B9B9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.75 17.5V38.75H12.5V17.5H38.75Z",
    fill: "#D9B400"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 18.125V38.125H38.125V18.125H13.125ZM36.925 36.9913H14.3V19.2587H36.95V36.9913H36.925ZM17.45 30.6588L18.3 31.4363L23.125 27.125L18.225 22.77L17.375 23.52L21.425 27.12L17.45 30.6588ZM23.125 31.9475H30.625V32.8362H23.125V31.9475Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCli);
export default __webpack_public_path__ + "static/media/cli.e37903efa28e5acdc19b3acd7f5d6f6f.svg";
export { ForwardRef as ReactComponent };